var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.value.customerOption === _vm.optionTypes.Create
      ? _c("div", { staticClass: "field" }, [
          _vm.ecomType === "estimage"
            ? _c("div", { staticClass: "mb-2" }, [
                _c(
                  "div",
                  {
                    staticClass: "pretty p-default p-round p-smooth is-size-7",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.isPerson,
                          expression: "value.isPerson",
                        },
                      ],
                      attrs: {
                        id: "chk-pretty-customer-type",
                        name: "chk-pretty-customer-type",
                        type: "radio",
                      },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.value.isPerson, false),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.value, "isPerson", false)
                        },
                      },
                    }),
                    _vm._m(0),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "pretty p-default p-round p-smooth is-size-7",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.isPerson,
                          expression: "value.isPerson",
                        },
                      ],
                      attrs: {
                        id: "chk-pretty-customer-type",
                        name: "chk-pretty-customer-type",
                        type: "radio",
                      },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.value.isPerson, true),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.value, "isPerson", true)
                        },
                      },
                    }),
                    _vm._m(1),
                  ]
                ),
              ])
            : _vm._e(),
          !_vm.value.isPerson
            ? _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Company Name")]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value.customerName,
                        expression: "value.customerName",
                      },
                    ],
                    staticClass: "input",
                    attrs: { placeholder: "Company Name" },
                    domProps: { value: _vm.value.customerName },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.value,
                            "customerName",
                            $event.target.value
                          )
                        },
                        _vm.assetExists,
                      ],
                    },
                  }),
                ]),
              ])
            : _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Firstname")]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.firstname,
                          expression: "value.firstname",
                        },
                      ],
                      staticClass: "input",
                      attrs: { placeholder: "Firstname" },
                      domProps: { value: _vm.value.firstname },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.value,
                              "firstname",
                              $event.target.value
                            )
                          },
                          _vm.assetExists,
                        ],
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Lastname")]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.lastname,
                          expression: "value.lastname",
                        },
                      ],
                      staticClass: "input",
                      attrs: { placeholder: "Lastname" },
                      domProps: { value: _vm.value.lastname },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.value, "lastname", $event.target.value)
                          },
                          _vm.assetExists,
                        ],
                      },
                    }),
                  ]),
                ]),
              ]),
          _c("div", { staticClass: "is-divider" }),
        ])
      : _vm._e(),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.customerOption,
              expression: "value.customerOption",
            },
          ],
          staticClass: "is-checkradio",
          attrs: { id: "createnew", type: "radio", name: "createnew" },
          domProps: {
            value: _vm.optionTypes.Create,
            checked: _vm._q(_vm.value.customerOption, _vm.optionTypes.Create),
          },
          on: {
            change: function ($event) {
              return _vm.$set(
                _vm.value,
                "customerOption",
                _vm.optionTypes.Create
              )
            },
          },
        }),
        _c("label", { attrs: { for: "createnew" } }, [
          _vm._v("Create new customer"),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.customerOption,
              expression: "value.customerOption",
            },
          ],
          staticClass: "is-checkradio",
          attrs: {
            id: "reuse",
            type: "radio",
            name: "reuse",
            disabled: !_vm.customerExists,
          },
          domProps: {
            value: _vm.optionTypes.Reuse,
            checked: _vm._q(_vm.value.customerOption, _vm.optionTypes.Reuse),
          },
          on: {
            change: function ($event) {
              return _vm.$set(
                _vm.value,
                "customerOption",
                _vm.optionTypes.Reuse
              )
            },
          },
        }),
        _c("label", { attrs: { for: "reuse" } }, [_vm._v("Use existing")]),
      ]),
    ]),
    !_vm.innerValue.isCreateQuote
      ? _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.customerOption,
                  expression: "value.customerOption",
                },
              ],
              staticClass: "is-checkradio",
              attrs: {
                id: "keepexisting",
                type: "radio",
                name: "keepexisting",
                disabled: !_vm.customerExists,
              },
              domProps: {
                value: _vm.optionTypes.KeepExisting,
                checked: _vm._q(
                  _vm.value.customerOption,
                  _vm.optionTypes.KeepExisting
                ),
              },
              on: {
                change: [
                  function ($event) {
                    return _vm.$set(
                      _vm.value,
                      "customerOption",
                      _vm.optionTypes.KeepExisting
                    )
                  },
                  function ($event) {
                    return _vm.setCustomerId(_vm.optionTypes.KeepExisting)
                  },
                ],
              },
            }),
            _c("label", { attrs: { for: "keepexisting" } }, [
              _vm._v("Keep existing"),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.value.customerOption === _vm.optionTypes.Reuse
      ? _c(
          "div",
          { staticClass: "field" },
          [
            _c("div", { staticClass: "is-divider" }),
            _c("label", { staticClass: "label" }, [
              _vm._v("Please select a customer"),
            ]),
            _c(
              "bulma-table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
                attrs: {
                  columns: _vm.columns,
                  "page-index": _vm.filter.pageIndex,
                  "page-size": _vm.filter.pageSize,
                  "total-rows": _vm.totalRows,
                  "is-loading": _vm.isTableLoading,
                  "sort-column": _vm.filter.sortColumn,
                  "sort-order": _vm.filter.sortOrder,
                  "show-pagination": false,
                },
                on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
              },
              [
                _vm._l(_vm.entitySummaries, function (entity, index) {
                  return _c(
                    "tr",
                    {
                      key: entity.messageId,
                      class: { "is-selected": _vm.selectedRow === index },
                      on: {
                        click: function ($event) {
                          return _vm.highlightSelected(index, $event)
                        },
                      },
                    },
                    [
                      _c("td", [_vm._v(" " + _vm._s(entity.fullName) + " ")]),
                      _c("td", { staticClass: "has-text-centered" }, [
                        _vm._v(
                          " " +
                            _vm._s(entity.streetName) +
                            ", " +
                            _vm._s(entity.suburb) +
                            " "
                        ),
                      ]),
                    ]
                  )
                }),
                _c("template", { slot: "empty" }, [
                  _c("section", { staticClass: "section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "content has-text-grey has-text-centered",
                      },
                      [
                        _c("span", { attrs: { icon: "icon is-large" } }, [
                          _c("i", {
                            staticClass: "mdi mdi-48px mdi-emoticon-sad",
                          }),
                        ]),
                        _c("p", [_vm._v("Nothing")]),
                      ]
                    ),
                  ]),
                ]),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.invalidCustomerId
      ? _c("span", { staticClass: "has-text-danger" }, [
          _vm._m(2),
          _vm._v(" Please select a customer before continuing. "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", { staticClass: "is-size-7" }, [_vm._v("Company")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", { staticClass: "is-size-7" }, [_vm._v("Person")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-alert-octagram mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }